import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { DateObject } from "react-multi-date-picker";
import _ from "underscore";
import { DateTime } from "luxon";
import { ToastContext } from "../../../context/ToastContext";
import { convertToBase64 } from "../../../utils/Helper.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




export const useEvents = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext)
    const [hoveredRange, setHoveredRange] = useState([new DateObject(), new DateObject().add(7, 'days')]);
    const [filterValues, setFilterValues] = useState({ event_type: "All", approved: { label: "Pending", value: "p" } });
    const [filterOpts, setFilterOpts] = useState({ event_type: [], approved: [{ label: "Pending", value: "p" }, { label: "Approved", value: "a" }, { label: "Rejected", value: "r" }] });
    const [loader, setLoader] = useState(false);
    const [loaderBtn, setLoaderBtn] = useState({ bupload: false, bsave: false, aupload: false, asave: false });
    const [bannerLoader, setBannerLoader] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [apiRowData, setApiRowData] = useState([]);
    const row = useRef(null);
    const gridRef = useRef(null);
    const bInputRef = useRef(null);
    const aInputRef = useRef(null);
    const [imageSelectedFlag, setImageSelectedFlag] = useState({ birthday: false, anniversary: false });
    const [imagePreview, setImagePreview] = useState({ birthday: null, anniversary: null });
    const [confirmation, setConfirmation] = useState(false);
    const [dataToReject, setDataToReject] = useState({});
    const [emailTemplate, setEmailTemplate] = useState({visible: false, html: ""})
    const coldef = [
        {
            field: "checkbox",
            headerName: "",
            headerComponent: () => {
                return (
                    <div className="w100">
                        {filterValues?.approved?.value === "p" ? <input type="checkbox" onChange={(e) => handleSelectAll(e)} /> : ""}
                    </div>
                )
            },
            cellStyle: { textAlign: "center" },
            width: 50,
            cellRenderer: (params) => {
                return (
                    <div>
                        <input type="checkbox" checked={params?.data?.is_approved === null ? (params?.data?.is_checked || false) : true} onChange={(e) => handleSelectAll(e, params)} disabled={params?.data?.is_approved === null ? false : true} />
                    </div>
                )
            }
        },
        {
            field: "event_Type",
            headerName: "Event Type",
            cellStyle: { textAlign: "center" },
            width: 120
        },
        {
            field: "employee_id",
            headerName: "Employee ID",
            cellStyle: { textAlign: "center" },
            width: 120
        },
        {
            field: "user_display_name",
            headerName: "Name",
            cellStyle: { textAlign: "center" },
            width: 180
        },
        {
            field: "event_date",
            headerName: "Birth Date",
            cellStyle: { textAlign: "center" },
            width: 100,
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && params?.data?.event_Type === "Birthday" ? DateTime.fromISO(params?.value).toFormat('dd MMM yyyy') : ""}</div>
                )
            }
        },
        {
            field: "joining_date",
            headerName: "Joining Date",
            cellStyle: { textAlign: "center" },
            width: 100,
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && params?.data?.event_Type === "Work Anniversary" ? DateTime.fromISO(params?.value).toFormat('dd MMM yyyy') : ""}</div>
                )
            }
        },
        {
            field: "resignation_date",
            headerName: "Resign Date",
            cellStyle: { textAlign: "center" },
            width: 100,
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? DateTime.fromISO(params?.value).toFormat('dd MMM yyyy') : ""}</div>
                )
            }
        },
        {
            field: "action",
            headerName: "Action",
            cellStyle: { textAlign: "center" },
            width: 160,
            valueGetter: params => {
                return params?.data?.is_approved
            },
            cellRenderer: (params) => {
                return (
                    <div>
                        <div className="d-flex justify-content-evenly">
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="radio" name={`"action-btn-${params?.data?.user_code + params?.data?.event_Type}"`} id={`action-approve-${params?.data?.user_code + params?.data?.event_Type}`} onChange={() => { if (!params?.data?.is_approved) { handleApproveReject(true, true, params?.data) } }} checked={params?.data?.is_approved} disabled={params?.data?.is_approved} />
                                <label htmlFor={`action-approve-${params?.data?.user_code + params?.data?.event_Type}`} style={{ cursor: "pointer" }}>Approve</label>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="radio" name={`"action-btn-${params?.data?.user_code + params?.data?.event_Type}"`} id={`action-reject-${params?.data?.user_code + params?.data?.event_Type}`} onChange={() => { if (params?.data?.is_approved || params?.data?.is_approved === null) { handleApproveReject(false, false, params?.data) } }} checked={!params?.data?.is_approved && params?.data?.is_approved !== null} disabled={!params?.data?.is_approved && params?.data?.is_approved !== null} />
                                <label htmlFor={`action-reject-${params?.data?.user_code + params?.data?.event_Type}`} style={{ cursor: "pointer" }}>Reject</label>
                            </div>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "email_celebrate_activity_banner",
            headerName: "Email Template",
            cellStyle: { textAlign: "center" },
            width: 100,
            hide: filterValues?.approved?.value !== "a",
            cellRenderer: (params) => {
                return (
                    <div>
                        {(params?.value && params?.data?.is_approved) ?
                            <div className="c-pointer" onClick={() => setEmailTemplate((prev) => ({...prev, visible: true, html: params?.value}))}><FontAwesomeIcon icon="fa-solid fa-image" /></div>
                            : ""}
                    </div>
                )
            }
        },
    ];

    useEffect(() => {
        if (hoveredRange?.[0] && hoveredRange?.[1]) {
            getEventsData();
        } else if (!hoveredRange?.[0] && !hoveredRange?.[1]) {
            setRowData([]);
        }
    }, [hoveredRange, filterValues?.event_type])

    useEffect(() => {
        if (showPopup) {
            setImageSelectedFlag({ birthday: false, anniversary: false })
            getBanner();
        }
    }, [showPopup])

    useEffect(() => {
        if (filterValues?.approved?.value === "p") {
            setRowData(_.filter(apiRowData, (item) => item?.is_approved === null));
            row.current = _.filter(apiRowData, (item) => item?.is_approved === null);
        } else {
            let rowdata = [];
            filterValues?.approved?.value === "a" ? rowdata = _.filter(apiRowData, (item) => item?.is_approved !== null && item?.is_approved) : rowdata = _.filter(apiRowData, (item) => item?.is_approved !== null && !item?.is_approved);
            setRowData(rowdata);
            row.current = rowdata;
        }
    }, [filterValues?.approved, apiRowData])

    const getEventsData = async () => {

        try {
            if (!hoveredRange?.[0] || !hoveredRange?.[1]) {
                showInfo("info", "Please select date range");
                return;
            }
            setLoader(true);
            const payload = {
                from_date: hoveredRange[0].toDate().toLocaleDateString("en-GB").split("/").reverse().join("-"),
                to_date: hoveredRange[1].toDate().toLocaleDateString("en-GB").split("/").reverse().join("-"),
                event_type: filterValues?.event_type === "All" ? "" : filterValues?.event_type || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUPCOMINGBIRTHDAYANNIVERSARYLIST"), payload);
            if (res) {
                const data = res?.body?.data?.birthday_anniversary_list;
                const sortedData = data.sort((a, b) => {
                    const approvalDiff = (a?.is_approved === null ? 0 : a?.is_approved ? 1 : 2) - (b?.is_approved === null ? 0 : b?.is_approved ? 1 : 2);
                    if (approvalDiff !== 0) return approvalDiff;
                    return a.event_Type.localeCompare(b.event_Type);
                });
                row.current = data;
                // setRowData(sortedData);
                setApiRowData(sortedData);
                setFilterOpts((prev) => ({ ...prev, event_type: ["All", "Birthday", "Work Anniversary"] }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const getBanner = async () => {
        try {
            setBannerLoader(true);
            const res = await services.getInvokeRemote("GET", Urls("GETCELEBRATEBANNERDETAILS"));
            if (res) {
                const data = res?.body?.data?.banner_details;
                const birthdayBanner = _.findWhere(data, { is_active: true, banner_type: "birthday" });
                const anniversaryBanner = _.findWhere(data, { is_active: true, banner_type: "anniversary" });
                if (imageSelectedFlag?.birthday && !imageSelectedFlag?.anniversary) {
                    setImagePreview((prev) => ({ ...prev, anniversary: anniversaryBanner?.image_url }));
                } else if (imageSelectedFlag?.anniversary && !imageSelectedFlag?.birthday) {
                    setImagePreview((prev) => ({ ...prev, anniversary: anniversaryBanner?.image_url }));
                } else if (!imageSelectedFlag?.anniversary && !imageSelectedFlag?.birthday) {
                    setImagePreview({ birthday: birthdayBanner?.image_url, anniversary: anniversaryBanner?.image_url });
                }

                setBannerLoader(false);
            }
        } catch (error) {
            console.error("error getting banners: ", error);
            setBannerLoader(false);
        }
    }

    const handleUploadClicked = (key) => {
        if (key) {
            setLoaderBtn((prev) => ({ ...prev, bupload: true }));
            bInputRef.current.value = "";
            bInputRef?.current?.click();
            setTimeout(() => {
                if (!bInputRef.current?.files?.length) {
                    setLoaderBtn((prev) => ({ ...prev, bupload: false }));
                }
            }, 5000);
        } else {
            setLoaderBtn((prev) => ({ ...prev, aupload: true }));
            aInputRef.current.value = "";
            aInputRef?.current?.click();
            setTimeout(() => {
                if (!aInputRef.current?.files?.length) {
                    setLoaderBtn((prev) => ({ ...prev, aupload: false }));
                }
            }, 5000);
        }
    }

    const handleFileChange = async (event, is_birthday) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = await convertToBase64(file);
            if (is_birthday) {
                setImagePreview((prev) => ({ ...prev, birthday: imageUrl }));
                setLoaderBtn((prev) => ({ ...prev, bupload: false }));
                setImageSelectedFlag((prev) => ({ ...prev, birthday: true }));
            } else {
                setImagePreview((prev) => ({ ...prev, anniversary: imageUrl }));
                setLoaderBtn((prev) => ({ ...prev, aupload: false }));
                setImageSelectedFlag((prev) => ({ ...prev, anniversary: true }));
            }
        }
    }

    const handleSelectAll = (event, rowdata) => {
        const data = [...row.current];
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = event?.target?.checked;
            const rowNode = gridRef.current.api.getDisplayedRowAtIndex(rowdata.node.rowIndex);
            rowNode.setData(data[rowdata.node.rowIndex]);
        } else {
            data.map((item) => item.is_checked = event.target.checked);
            setRowData(data);
        }
    }

    const handleApproveReject = async (key, confirmed, data) => {
        try {
            if (_.isEmpty(_.filter(row.current, { is_checked: true })) && !data) {
                showInfo("info", "Please select an event to approve/reject");
                return;
            } else if (!confirmed) {
                setConfirmation(true);
                data && setDataToReject(data);
                return;
            }
            let tvpArray = [];
            if (!_.isEmpty(data)) {
                const obj = {
                    user_code: data?.user_code,
                    event_datetime: data?.event_date,
                    banner_id: data?.banner_id,
                    is_approved: key ? true : false,
                    is_rejected: key ? false : true
                }
                tvpArray.push(obj);
            } else {
                const selectedData = _.filter(row.current, { is_checked: true, is_approved: null });
                selectedData?.forEach((item) => {
                    const obj = {
                        user_code: item?.user_code,
                        event_datetime: item?.event_date,
                        banner_id: item?.banner_id,
                        is_approved: key ? true : false,
                        is_rejected: key ? false : true
                    }
                    tvpArray.push(obj);
                })
            }
            const payload = {
                tvp_celebrate_activity_upsert: tvpArray
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTCELEBRATEACTIVITYSTATUS"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                getEventsData();
                setDataToReject({});
                setConfirmation(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
            const data = row.current.map(item => ({
                ...item,
                is_checked: item.is_checked ? false : item.is_checked
            }));

            setRowData(data);
            row.current = data;
        }
    }

    const handleSaveBanner = async (key) => {
        try {
            if (!imagePreview[key]) {
                showInfo("info", `Please select a banner for ${key}`);
                return;
            } else if (!imageSelectedFlag[key]) {
                showInfo("Info", "Selected banner is already saved");
                return;
            }
            key === "birthday" ? setLoaderBtn((prev) => ({ ...prev, bsave: true })) : setLoaderBtn((prev) => ({ ...prev, asave: true }));
            const payload = {
                banner_id: 0,
                banner_type: key,
                image_data: imagePreview[key]?.split(",")?.[1],
                is_active: true
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTCELEBRATEBANNERDETAILS"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setImageSelectedFlag((prev) => ({ ...prev, [key]: false }));
                getBanner();
                getEventsData();
                key === "birthday" ? setLoaderBtn((prev) => ({ ...prev, bsave: false })) : setLoaderBtn((prev) => ({ ...prev, asave: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            key === "birthday" ? setLoaderBtn((prev) => ({ ...prev, bsave: false })) : setLoaderBtn((prev) => ({ ...prev, asave: false }));
        }
    }

    return useMemo(() => ({
        hoveredRange, setHoveredRange, coldef, rowData, setRowData, loader, showPopup, setShowPopup, handleUploadClicked, handleFileChange, imagePreview, setImagePreview, gridRef, handleApproveReject, aInputRef, bInputRef, handleSaveBanner, loaderBtn, setLoaderBtn, getEventsData, bannerLoader, imageSelectedFlag, confirmation, setConfirmation, dataToReject, filterValues, setFilterValues, filterOpts, emailTemplate, setEmailTemplate
    }), [hoveredRange, setHoveredRange, coldef, rowData, setRowData, loader, showPopup, setShowPopup, handleUploadClicked, handleFileChange, imagePreview, setImagePreview, gridRef, handleApproveReject, aInputRef, bInputRef, handleSaveBanner, loaderBtn, setLoaderBtn, getEventsData, bannerLoader, imageSelectedFlag, confirmation, setConfirmation, dataToReject, filterValues, setFilterValues, filterOpts, emailTemplate, setEmailTemplate])
}